<template>
  <el-dialog
      :visible.sync="visible"
      title="加工单设置" :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :span="6">
          <el-form-item label="外销合同编号：" prop="orderCode">
            <order-drop v-model="dataForm.orderCode" placeholder="请输入外销合同编号"
                        :disabled="$c.str2bool(dataForm.id) "></order-drop>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="工厂：" prop="companyId" label-width="80px">
            <factory v-model="dataForm.companyId" :showBtn="true"
                     :disabled="$c.str2bool(dataForm.id)&&dataForm.status!==10"></factory>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="交付日期：" prop="deadline">
            <el-date-picker
                size="mini"
                v-model="dataForm.deadline"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="选择交付日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="工艺/步骤：" prop="technologyId">
            <technology v-model="dataForm.technologyId"></technology>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="备注：" prop="remark">
            <el-input v-model="dataForm.remark" placeholder="备注" size="mini"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="flex-r">
        <el-button type="primary" size="mini" @click="showAgreementDetail">选择品番</el-button>
      </div>
      <SweetTable :data="dataForm.detailList" :is-page="false" :summaries-column="['currentTotalAmount']">
        <el-table-column
            label="品番信息"
            prop="product.code"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true" min-width="200"
        >
          <template #default="{row}">
            <ProductRowCard :product="row.product"></ProductRowCard>
          </template>
        </el-table-column>
        <el-table-column
            prop="receiveCount"
            label="已收货"
            header-align="center"
            align="center"
            width="100" v-if="dataForm&&dataForm.id"
        ></el-table-column>
        <el-table-column
            label="加工数量"
            header-align="center"
            align="center"
            width="140"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.count'"
                :rules="detailRule.count"
                label-width="0"
                style="margin-bottom: 0px;"
            >
              <el-input
                  size="mini"
                  v-model="scope.row.count"
                  @change="(e) => amountChange(e, scope.row)"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="加工费单价"
            header-align="center"
            align="center"
            width="140"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.amount'"
                :rules="detailRule.amount"
                label-width="0"
                style="margin-bottom: 0px;"
            >
              <el-input
                  size="mini"
                  v-model="scope.row.amount"
                  @change="(e) => amountChange(e, scope.row)"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="包装检品费单价"
            header-align="center"
            align="center"
            width="140"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.checkAmount'"
                :rules="detailRule.checkAmount"
                label-width="0"
                style="margin-bottom: 0px;"
            >
              <el-input
                  size="mini"
                  v-model="scope.row.checkAmount"
                  placeholder="请输入包装检品费单价"
                  @change="(e) => amountChange(e, scope.row)"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="纸箱单价"
            header-align="center"
            align="center"
            width="140"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.packPrice'"
                :rules="detailRule.packPrice"
                label-width="0"
                style="margin-bottom: 0px;"
            >
              <el-input
                  size="mini"
                  v-model="scope.row.packPrice"
                  placeholder="请输入纸箱单价" @change="(e) => amountChange(e, scope.row)"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="中棉单价"
            header-align="center"
            align="center"
            width="140"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.cottonPrice'"
                :rules="detailRule.packPrice"
                label-width="0"
                style="margin-bottom: 0px;"
            >
              <el-input
                  size="mini"
                  v-model="scope.row.cottonPrice"
                  placeholder="请输入中棉单价" @change="(e) => amountChange(e, scope.row)"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="运费单价"
            header-align="center"
            align="center"
            width="140"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.freightPrice'"
                :rules="detailRule.freightPrice"
                label-width="0"
                style="margin-bottom: 0px;"
            >
              <el-input
                  size="mini"
                  v-model="scope.row.freightPrice"
                  placeholder="请输入运费单价" @change="(e) => amountChange(e, scope.row)"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            prop="totalPrice"
            label="加工费总价"
            header-align="center"
            align="center"
            width="140"
        ></el-table-column>
        <el-table-column
            label="已收货金额"
            header-align="center"
            align="center"
            width="140"
            prop="currentTotalAmount"
        >
          <template #default="{row}">
            <span v-if="dataForm&&!dataForm.id">{{ row.currentTotalAmount }}</span>
            <span
                v-if="dataForm&&dataForm.id&&row.currentTotalAmount==row.sendTotalAmount">{{
                row.currentTotalAmount
              }}</span>
            <span style="color: red;"
                  v-if="dataForm&&dataForm.id&&row.currentTotalAmount!=row.sendTotalAmount">{{
                row.sendTotalAmount
              }}->{{ row.currentTotalAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            width="100"
            label="操作"
        >
          <template slot-scope="scope">
            <el-button
                type="text"
                icon="el-icon-remove"
                size="mini"
                @click="delRow(scope.$index, scope.row, 'detailList')"
            >移除
            </el-button
            >
          </template>
        </el-table-column>
      </SweetTable>
    </el-form>
    <template #footer>
      <div class="flex-b">
        <div >
          <el-checkbox v-if="dataForm&&dataForm.id" v-model="refreshPrice">同步更新发货单价</el-checkbox>
        </div>
        <div>
          <el-button @click="cancel()" size="mini">{{ $t('cancel') }}</el-button>
          <el-button type="primary" size="mini" @click="dataFormSubmitHandle()">{{
              $t('confirm')
            }}
          </el-button>
        </div>
      </div>

    </template>
    <OrderDetailDialog
        ref="orderDetailDialog"
        @selected="detailSelected"
    ></OrderDetailDialog>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import BigNumber from 'bignumber.js'
import SingleFileUpload from '@/components/SingleFileUpload'
import OrderDetailDialog from '@/components/order-detail-dialog'
import Technology from '@/components/technology/index.vue'
import { isNumber, moneyValidator } from '@/utils/validate'
import ProductRowCard from '@/components/ProductRowCard.vue'

export default {
  mixins: [],
  components: { ProductRowCard, SingleFileUpload, OrderDetailDialog, Technology },
  data () {
    return {
      refreshPrice: false,
      dataForm: {},
      agreementInfo: {},
      visible: false,
    }
  },
  computed: {
    detailRule () {
      return {
        name: [{ required: true, message: '请填写名称', trigger: 'change' }],
        code: [{ required: true, message: '请填写品番号', trigger: 'change' }],
        amount: [
          { required: true, message: '请填写正确的金额', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ],
        checkAmount: [
          { required: true, message: '请填写单价', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ],
        packPrice: [
          { required: true, message: '请填写单价', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ],
        count: [
          { required: true, message: '请填写数量', trigger: 'change' },
          {
            validator: function (rule, value, callback) {
              if (!isNumber(value)) {
                callback(new Error('请输入正确的数量'))
              }
              callback()
            },
            trigger: 'change',
          },
        ],
      }
    },
    dataRule () {
      return {
        orderCode: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'change',
        }],
        companyId: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'change',
        }]
      }
    },
  },
  beforeRouteLeave (to, from, next) {
    if (this.$refs.orderDetailDialog) {
      this.$refs.orderDetailDialog.clearSelection()
    }
    next()
  },
  methods: {
    //合同明细选择回调
    detailSelected (e) {
      let detailList = [...this.dataForm.detailList]
      if (e && e.length > 0) {
        e.forEach((item, index) => {
          item.amount = ''
          item.checkAmount = 0
          item.packPrice = 0
          item.agreementDetailId = item.id
          item.totalPrice = 0
          item.cottonPrice = 0
          item.freightPrice = 0
          item.id = detailList.length + 1
          detailList.push(item)
        })
      }
      this.$set(this.dataForm, 'detailList', detailList)
    },
    //显示合同明细弹窗
    showAgreementDetail () {
      this.$refs.dataForm.validateField('orderCode', (valid, object) => {
        if (!valid) {
          if (this.dataForm.detailList && this.dataForm.detailList.length > 0) {
            this.$refs.orderDetailDialog.dataForm.exProductIds = this.dataForm.detailList
                .map((item) => item.productId)
                .join(',')
          } else {
            this.$refs.orderDetailDialog.dataForm.exProductIds = ''
          }

          this.$refs.orderDetailDialog.dataForm.orderCode = this.dataForm.orderCode
          this.$refs.orderDetailDialog.init()
        } else {
          this.$message.error('请先选择订单')
        }
      })
    },
    amountChange (e, row) {
      this.computePrice(row)
    },
    computePrice (row) {
      let priceTemplate = ['amount', 'checkAmount', 'packPrice', 'cottonPrice', 'freightPrice']
      let totalP = new BigNumber(0)
      priceTemplate.forEach(pt => {
        let tmpPrice = new BigNumber(row[pt] ? row[pt] : 0)
        if (tmpPrice.isNaN()) {
          console.log(pt, tmpPrice.toFixed(2))
          return
        }
        totalP = totalP.plus(tmpPrice)
      })
      const currentTotalAmount = totalP.multipliedBy(row.receiveCount ? row.receiveCount : 0)
      this.$set(row, 'currentTotalAmount', currentTotalAmount.toFixed(2))
      this.$set(row, 'totalPrice', totalP.toFixed(3))
    },
    delRow (index, row, dataKey) {
      if (this.dataForm[dataKey]) {
        this.dataForm[dataKey].splice(index, 1)
      }
    },
    //修改时读取单据信息
    async getInfo () {
      const res = await this.$api2.get(`/erp/make/${this.dataForm.id}`)
      this.$set(this, 'dataForm', res)
      this.refreshPrice = true
    },
    async reset (id) {
      this.dataForm = {
        id: id ? id : '',
        remark: '',
        totalPrice: '',
        code: '',
        companyId: '',
        agreementId: '',
        deadline: '',
        orderCode: '',
        technologyId: '',
        detailList: [],
        chargeList: []
      }
      if (this.dataForm.id) {
        await this.getInfo()
        if (!this.$c.isArrayEmpty(this.dataForm.detailList)) {
          this.dataForm.detailList.forEach((row, rowIndex) => {
            this.computePrice(row)
          })
        }
      }
    },
    async init (id) {
      await this.reset(id)
      this.visible = true
      this.$nextTick(() => {
        if (this.$refs['dataForm']) {
          this.$refs['dataForm'].clearValidate()
        }
      })
    },
    cancel () {
      this.visible = false
    },
    async doSave () {
      //判断加工单是否有关联的进项发票
      if(this.dataForm.id){
        const hasInvoiceData=await this.$api2.get(`/erp/make/hasInvoice/${this.dataForm.id}`)
        if(hasInvoiceData.data){
          await this.$confirm('本次操作将会更新所有关联发货记录的发货单价(不包含已开进项发票)，是否继续？')
        }
      }

      let postForm = this.$clone(this.dataForm)
      postForm.refreshPrice = this.refreshPrice
      if (postForm.detailList && postForm.detailList.length === 0) {
        return this.$message.error('合同明细不能为空')
      }
      postForm.detailList.forEach((item) => {
        if (String(item.id).length < 6) {
          item.id = null
        }
      })
      const loading = this.$loading()
      try {
        await this.$api2.post('/erp/make/save', postForm)
        this.$emit('changed')
        this.$message.success(this.$t('prompt.success'))
        this.cancel()
      } catch (e) {
        console.log('doSave', e)
      } finally {
        loading.close()
      }
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            if(this.refreshPrice){
              this.$confirm('本次更新会同步刷新所有关联发货记录的发货单价(不包含已开进项发票)，是否继续？').then(() => {
                this.doSave()
              })
            }else{
              this.doSave()
            }
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
  },
}
</script>
